import React from 'react';
import {cropRectToImagePosition, getBoxSize, getCropRectFillInByProduct} from "../../../utils";
import {getProductOrientationByCropRect, getProductSizeInPixels, imageQualityWarning} from "../../../lib/imageutils";


const getData = (imageSize, containerSize, product, cropRect, whiteBorder, adaption) => {

  if (!cropRect) {
    cropRect = getCropRectFillInByProduct(imageSize, product, whiteBorder);
  }

  const orientation = getProductOrientationByCropRect(product, cropRect);

  let printAreaSize = getProductSizeInPixels(product);
  if (orientation == 'portrait') {
    printAreaSize = {width: printAreaSize.height, height: printAreaSize.width};
  }

  const paper = getBoxSize('fit-in', printAreaSize, containerSize);

  let whiteBorderWidth = 0;
  if (whiteBorder) {
    whiteBorderWidth = Math.min(paper.width, paper.height)*0.05;
  }

  const imageArea = {
    width: paper.width - (whiteBorderWidth*2),
    height: paper.height - (whiteBorderWidth*2)
  };

  const imagePos = cropRectToImagePosition(cropRect, imageSize, imageArea, adaption);

  const imagePixels = cropRect.width * cropRect.height;
  const imageAreaPixels = printAreaSize.width * printAreaSize.height;

  const qualityWarning = imageQualityWarning(imageAreaPixels, imagePixels);

  console.log('useImagePreview, Image position', imagePos, cropRect, adaption);

  const data = {
    paper: {width: paper.width, height: paper.height},
    imageContainer: {...imageArea, y: whiteBorderWidth, x: whiteBorderWidth},
    image: imagePos,
    qualityWarning
  }

  console.log('Calculated image position', data, cropRect);;

  return data;
}

export default (imageSize, containerSize, product, cropRect, whiteBorder, adaption) => {
    return React.useMemo(() => {
      return getData(imageSize, containerSize, product, cropRect, whiteBorder, adaption);
    }, [imageSize, containerSize, product, cropRect, whiteBorder, adaption]);
}